/*
* Pipeline Theme — Elwards Leather Custom JS
*/

(function() {

  /* =========================================================================
     "You Save" badge — update save percent on variant change
     ========================================================================= */
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (!variant) return;

    var savePercentEls = container.querySelectorAll('[data-save-percent]');
    if (savePercentEls.length && variant.compare_at_price && variant.compare_at_price > variant.price) {
      var percent = Math.floor(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      savePercentEls.forEach(function(el) {
        el.textContent = percent + '%';
      });
    }

    updateStickyATCVariant(variant);
  });

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var formatted = Shopify.formatMoney(cents, theme.moneyFormat);
      if (theme.settings.currency_code_enable) {
        formatted += ' ' + theme.currencyCode;
      }
      return formatted;
    }
    return (cents / 100).toFixed(2);
  }

  function updateStickyATCVariant(variant) {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var priceEl = bar.querySelector('[data-sticky-atc-current-price]');
    var compareEl = bar.querySelector('[data-sticky-atc-compare-price]');
    var btn = bar.querySelector('[data-sticky-atc-button]');
    var btnText = bar.querySelector('[data-sticky-atc-text]');
    var btnPrice = bar.querySelector('[data-sticky-atc-btn-price]');
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (priceEl) {
      priceEl.innerHTML = formatMoney(variant.price);
      priceEl.classList.toggle('sticky-atc__price--sale', onSale);
    }
    if (compareEl) {
      compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
      compareEl.style.display = onSale ? '' : 'none';
    }
    if (btnPrice) {
      btnPrice.innerHTML = '<span class="sticky-atc__button-sep">—</span>' + formatMoney(variant.price);
    }
    if (btn && btnText) {
      btn.disabled = !variant.available;
      btnText.textContent = variant.available
        ? (theme.strings.addToCart || 'Add to cart')
        : (theme.strings.soldOut || 'Sold out');
    }
  }

  /* =========================================================================
     Sticky Add to Cart bar — scroll-based show/hide
     ========================================================================= */
  function initStickyATC() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    /* Find the product form wrapper — more reliable than the button itself */
    var formWrapper = document.querySelector('[data-product-form]');
    if (!formWrapper) {
      formWrapper = document.querySelector('form[action="/cart/add"]');
    }
    if (!formWrapper) return;

    var mainButton = formWrapper.querySelector('[data-add-to-cart]') || formWrapper.querySelector('button[name="add"]');
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');

    /* Hide the bar once the viewport reaches the footer / subfooter — that's
       the only "end of page" area we don't want it covering. */
    var hideZoneSelector = 'footer,[id^="shopify-section-footer"],[id^="shopify-section-subfooter"]';
    var hideZoneTop = Infinity;
    function recomputeHideZone() {
      var min = Infinity;
      document.querySelectorAll(hideZoneSelector).forEach(function (el) {
        if (el === bar || bar.contains(el) || el.contains(bar)) return;
        var rect = el.getBoundingClientRect();
        var absTop = rect.top + window.scrollY;
        if (absTop > 0 && absTop < min) min = absTop;
      });
      hideZoneTop = min;
    }

    recomputeHideZone();

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var rect = formWrapper.getBoundingClientRect();
        var formPassed = rect.bottom < 0;
        var nearHideZone = (window.scrollY + window.innerHeight) >= (hideZoneTop - 20);
        if (formPassed && !nearHideZone) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
        ticking = false;
      });
    }

    function onLayoutChange() {
      recomputeHideZone();
      onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onLayoutChange);
    window.addEventListener('load', onLayoutChange);

    onScroll();

    /* Click sticky button -> trigger main form + mirror animation */
    if (stickyButton && mainButton && !stickyButton._bound) {
      stickyButton._bound = true;
      stickyButton.addEventListener('click', function() {
        /* Show loading state */
        stickyButton.classList.add('loading');
        stickyButton.classList.remove('has-success');

        /* Trigger the real form */
        mainButton.click();

        /* Watch for the main button's success state */
        var checkCount = 0;
        var checker = setInterval(function() {
          checkCount++;
          if (mainButton.classList.contains('has-success')) {
            clearInterval(checker);
            stickyButton.classList.remove('loading');
            stickyButton.classList.add('has-success');
            setTimeout(function() {
              stickyButton.classList.remove('has-success');
            }, 2000);
          } else if (checkCount > 50) {
            /* Timeout after 5s — reset */
            clearInterval(checker);
            stickyButton.classList.remove('loading');
          }
        }, 100);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
  document.addEventListener('shopify:section:load', initStickyATC);

  /* =========================================================================
     Size Guide modal — open/close
     ========================================================================= */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      e.preventDefault();
      var modal = document.querySelector('[data-size-guide-modal]');
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    var closeBtn = e.target.closest('[data-size-guide-close]');
    if (closeBtn) {
      var openModal = closeBtn.closest('[data-size-guide-modal]');
      if (openModal) {
        openModal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('[data-size-guide-modal].is-open');
      if (openModal) {
        openModal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

})();
